
<template>
  <v-app id="onHust">
    <v-main>
    <v-container fluid>  
    <v-card>
      
      Code: {{hust.hust_code}}  

      <span v-for="(husttaalRecord,i) in hust.husttaal" :key="i">
       <br>
       {{husttaalRecord.taal_code}}  <v-btn class="primary ma-2" small @click="saveHusttaal(husttaalRecord)">Save</v-btn><br>
       <v-textarea v-model="husttaalRecord.husttaal_oms" :value=husttaalRecord.husttaal_oms rows="1" label="Translation (ysa)" spellcheck="false"></v-textarea>
       <br>
      </span>  
    </v-card>  
    </v-container>
    </v-main>
    <navBar title="Ares - Reference data" :home="true" type="referencedata"/>
  </v-app>
</template>


<script>
import navBar from "@/components/ui/navbars/navbar.vue";
 export default {
  components: {
    navBar
  },
  props: ['hust_encrid'],
  data() {
    return {
      hust: {}
    }  
  },
  mounted() {
      this.$axios
        .post("ares/json/ares/syst/ref/hust/getHust.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHust"
          },
          getHust: {
             hust_encrid: this.hust_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.hust = res.data.getHust;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  methods: {
    saveHusttaal(husttaal) { 
      this.$axios
        .post("ares/json/ares/syst/ref/hust/saveHusttaal.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "saveHusttaal"
          },
          saveHusttaal: {
            husttaal: husttaal
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else {
            this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.saveHusttaal.text,
              color: res.data.saveHusttaal.color
            });
          }
        })
    }
  }  

};

</script> 
